import React, { useState } from 'react';
import styles from '../../../styles/scss/system/Users.module.scss';
import { useAdminLanguage } from '../../../AdminLanguageContext';
import { translateAdmin } from '../../../utils/adminTranslations';


const UserView = ({ user, onClose }) => {
    const { language } = useAdminLanguage();
    const translate = (text) => translateAdmin(text, language);
    const [viewUser] = useState(user);
    return (
        <div className={styles.modalOverlay} role="presentation">
            <section className={styles.modalDialog} role="dialog" aria-modal="true" aria-labelledby="view-user-title">
                <header className={styles.modalHeader}>
                    <div>
                        <span className={styles.eyebrow}>{translate('КАРТОЧКА СОТРУДНИКА')}</span>
                        <h2 id="view-user-title">{translate('Пользователь')}</h2>
                        <p>{translate('Информация об учетной записи и назначенной роли.')}</p>
                    </div>
                    <button type="button" className={styles.modalClose} onClick={onClose} aria-label={translate('Закрыть')}>×</button>
                </header>
                <div className={styles.modalForm}>
                    <div className={styles.modalFields}>
                        <div className={styles.modalField}>
                            <span>{translate('Логин')}</span>
                            <div className={styles.readOnlyValue}>{viewUser.username || '—'}</div>
                        </div>
                        <div className={styles.modalField}>
                            <span>{translate('Имя')}</span>
                            <div className={styles.readOnlyValue}>{viewUser.first_name || '—'}</div>
                        </div>
                        <div className={styles.modalField}>
                            <span>{translate('Фамилия')}</span>
                            <div className={styles.readOnlyValue}>{viewUser.last_name || '—'}</div>
                        </div>
                        <div className={styles.modalField}>
                            <span>{translate('Роль')}</span>
                            <div className={styles.readOnlyValue}>
                                <span className={styles.roleBadge}>{translate(viewUser.role_name || 'Роль не установлена')}</span>
                            </div>
                        </div>
                    </div>
                    <footer className={styles.modalFooter}>
                        <button type='button' className={styles.secondaryButton} onClick={onClose}>{translate('Закрыть')}</button>
                    </footer>
                </div>
            </section>
        </div>
    );
}

export default UserView;